import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("mmko_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("mmko_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("mmko_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (email, password, display_name) => {
    const { data } = await api.post("/auth/register", { email, password, display_name });
    localStorage.setItem("mmko_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("mmko_token");
    setUser(null);
  };

  const updateProfile = async (patch) => {
    const { data } = await api.put("/users/me", patch);
    setUser(data);
    return data;
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, refresh, updateProfile }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
